module.exports = __webpack_public_path__ + "static/13-dd465ddd451ed4623e001f5fb3b13201.jpg";